import { render } from "./IziGrid.vue?vue&type=template&id=403269fe&scoped=true"
import script from "./IziGrid.vue?vue&type=script&lang=ts"
export * from "./IziGrid.vue?vue&type=script&lang=ts"

import "./IziGrid.vue?vue&type=style&index=0&id=403269fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-403269fe"

export default script